document.addEventListener('DOMContentLoaded', function () {
  $('.nav.nav-tabs .tabs-container').on('scroll', function () {
    var $tabContainer = $(this),
      $navTabs = $tabContainer.parent('.nav.nav-tabs'),
      scrollLeft = $tabContainer.scrollLeft(),
      scrollWidth = $tabContainer.prop('scrollWidth'),
      clientWidth = $tabContainer.prop('clientWidth');
    $navTabs[scrollLeft > 0 ? 'addClass' : 'removeClass']('can-scroll-left');
    $navTabs[scrollLeft + clientWidth < scrollWidth ? 'addClass' : 'removeClass']('can-scroll-right');
  });
});